const toDateOnlyString = (dateValue) => {
  if (!dateValue) return null

  const date = new Date(dateValue)

  return date.toISOString().split('T')[0]
}

export default toDateOnlyString
